import GoalReminderNotification from './GoalReminderNotification';

export default GoalReminderNotification;